/* eslint-disable no-use-before-define */
import React, { useEffect } from 'react'
import { useLocation, matchPath } from 'react-router-dom'
import { Link as RouterLink } from 'react-router-dom'
import PerfectScrollbar from 'react-perfect-scrollbar'
import PropTypes from 'prop-types'
import {
  Avatar,
  Box,
  Divider,
  Drawer,
  Hidden,
  Link,
  List,
  ListSubheader,
  makeStyles,
} from '@material-ui/core'
import ReceiptIcon from '@material-ui/icons/ReceiptOutlined'
import PaymentOutlinedIcon from '@material-ui/icons/PaymentOutlined'
import {
  // Briefcase as BriefcaseIcon,
  Calendar as CalendarIcon,
  DollarSign as DollarSignIcon,
  Folder as FolderIcon,
  ShoppingCart as ShoppingCartIcon,
  Lock as LockIcon,
  UserPlus as UserPlusIcon,
  Home as HomeIcon,
  Settings as SettingsIcon,
  // Trello as TrelloIcon,
  User as UserIcon,
  Users as UsersIcon,
  Clipboard as ClipboardIcon,
  Package as PackageIcon,
} from 'react-feather'
import AccountBalanceWalletOutlinedIcon from '@material-ui/icons/AccountBalanceWalletOutlined'
import AccountBalanceOutlinedIcon from '@material-ui/icons/AccountBalanceOutlined'
import EventAvailableOutlinedIcon from '@material-ui/icons/EventAvailableOutlined'
import LocalAtmOutlinedIcon from '@material-ui/icons/LocalAtmOutlined'
import AccessibilityNewOutlinedIcon from '@material-ui/icons/AccessibilityNewOutlined'
import GroupAddOutlinedIcon from '@material-ui/icons/GroupAddOutlined'
import EqualizerOutlinedIcon from '@material-ui/icons/EqualizerOutlined';
import Logo from 'src/components/Logo'
import useAuth from 'src/hooks/useAuth'
import NavItem from './NavItem'

const sections = [
  {
    subheader: 'Management',
    items: [
      // {
      //   title: 'Products',
      //   icon: ShoppingCartIcon,
      //   href: '/app/management/products',
      //   items: [
      //     {
      //       title: 'List Products',
      //       href: '/app/management/products'
      //     },
      //     {
      //       title: 'Create Product',
      //       href: '/app/management/products/create'
      //     }
      //   ]
      // },
      // {
      //   title: 'Accounts',
      //   href:"/app/account",
      //   icon: UsersIcon,
      // },

      {
        title: 'Roster',
        href: '/app/roster-v2',
        icon: EventAvailableOutlinedIcon,
      },

      {
        title: 'Appointment',
        href: '/app/appointment',
        icon: CalendarIcon,
      },
      // {
      //   title: 'Shift',
      //   href: '/app/shift',
      //   icon: CalendarIcon
      // },
      // {
      //   title: 'Members',
      //   icon: UsersIcon,
      //   href: '/app/management/members',
      //   items: [
      //     {
      //       title: 'All',
      //       href: '/app/management/members'
      //     },
      //     {
      //       title: 'Create member',
      //       href: '/app/management/members/create'
      //     },
      //   ]
      // },
      {
        title: 'Customers',
        icon: UsersIcon,
        href: '/app/management/customers',
        // items:
        //  [
        //   {
        //     title: 'All',
        //     href: '/app/management/customers',
        //   },
        //   {
        //     title: 'Create Customer',
        //     href: '/app/management/customer/create',
        //   },
        // ],
      },
      // {
      //   title: 'Products',
      //   icon: ShoppingCartIcon,
      //   href: '/app/management/products'
      // },
      {
        title: 'Orders',
        icon: FolderIcon,
        href: '/app/management/orders',
        // items: [
        //   {
        //     title: 'All',
        //     href: '/app/management/orders',
        //   },
        //   {
        //     title: 'Create Order',
        //     href: '/app/management/order/create',
        //   },
        // ],
      },
      {
        title: 'Products',
        icon: ClipboardIcon,
        href: '/app/management/products',
      },
      {
        title: 'Inventory',
        icon: PackageIcon,
        href: '/app/management/inventory',
      },
      {
        title: 'Payment',
        icon: PaymentOutlinedIcon,
        href: '/app/management/paymentmethod',
      },
      {
        title: 'Room',
        icon: HomeIcon,
        href: '/app/management/room',
      },
      {
        title: 'Employee',
        icon: GroupAddOutlinedIcon,
        href: '/app/management/employee',
      },

      // {
      //   title: 'Payment',
      //   icon: DollarSignIcon,
      //   href: '/app/management/orders',
      //   items: [
      //     {
      //       title: 'All',
      //       href: '/app/management/payment/all'
      //     },
      //     {
      //       title: 'Pending',
      //       href: '/app/management/payment/pending'
      //     },
      //     {
      //       title: 'Completed',
      //       href: '/app/management/payment/completed'
      //     },
      //     ,
      //     {
      //       title: 'Create Payment',
      //       href: '/app/management/payment/create'
      //     }
      //   ]
      // },
    ],
  },
  {
    subheader: 'Finance',
    items: [     
      {
        title: 'Income',
        href: '/app/finance/income',
        icon: LocalAtmOutlinedIcon,
      },
      {
        title: 'Expense',
        href: '/app/finance/expense',
        icon: AccountBalanceOutlinedIcon,
      },
      {
        title: 'Summary',
        icon: ReceiptIcon,
        href: '/app/finance/summary',
      },
      {
        title: 'Salary',
        icon: AccountBalanceWalletOutlinedIcon,
        href: '/app/finance/salary',
      },
      {
        title: 'Commission',
        icon: AccessibilityNewOutlinedIcon,
        href: '/app/finance/commission',
      },
      {
        title: 'Graph',
        href: '/app/finance/graph',
        icon: EqualizerOutlinedIcon,
      }
    ],
  },
  {
    subheader: 'Auth',
    items: [
      // {
      //   title: 'Login',
      //   href: '/login-unprotected',
      //   icon: LockIcon
      // },
      // {
      //   title: 'Register',
      //   href: '/register-unprotected',
      //   icon: UserPlusIcon,
      // },
      {
        title: 'Accounts',
        href: '/app/accounts',
        icon: UsersIcon,
      },
      {
        title: 'Role',
        href: '/app/role',
        icon: SettingsIcon,
      },
    ],
  },
]

function renderNavItems({ items, pathname, depth = 0 }) {
  return (
    <List disablePadding>
      {items.reduce(
        (acc, item) => reduceChildRoutes({ acc, item, pathname, depth }),
        []
      )}
    </List>
  )
}

function reduceChildRoutes({ acc, pathname, item, depth }) {
  const key = item.title + depth

  if (item.items) {
    const open = matchPath(pathname, {
      path: item.href,
      exact: false,
    })

    acc.push(
      <NavItem
        depth={depth}
        icon={item.icon}
        info={item.info}
        key={key}
        open={Boolean(open)}
        title={item.title}
      >
        {renderNavItems({
          depth: depth + 1,
          pathname,
          items: item.items,
        })}
      </NavItem>
    )
  } else {
    acc.push(
      <NavItem
        depth={depth}
        href={item.href}
        icon={item.icon}
        info={item.info}
        key={key}
        title={item.title}
      />
    )
  }

  return acc
}

const useStyles = makeStyles(() => ({
  mobileDrawer: {
    width: 256,
  },
  desktopDrawer: {
    width: 256,
    top: 64,
    height: 'calc(100% - 64px)',
  },
  avatar: {
    cursor: 'pointer',
    width: 64,
    height: 64,
  },
}))

const NavBar = ({ onMobileClose, openMobile }) => {
  const classes = useStyles()
  const location = useLocation()
  const { account } = useAuth()

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname])

  const content = (
    <Box height='100%' display='flex' flexDirection='column'>
      <PerfectScrollbar options={{ suppressScrollX: true }}>
        <Hidden lgUp>
          <Box p={2} display='flex' justifyContent='center'>
            {/* <RouterLink to="/">
              <Logo />
            </RouterLink> */}
          </Box>
        </Hidden>
        <Box p={2}>
          <Box display='flex' justifyContent='center'>
            <RouterLink to='/app/account'>
              <Avatar
                alt='Account'
                className={classes.avatar}
                src={account.AccountCircleRoundedIcon}
              />
            </RouterLink>
          </Box>
          <Box mt={2} textAlign='center'>
            <Link
              component={RouterLink}
              to='/app/account'
              variant='h5'
              color='textPrimary'
              underline='none'
            >
              {account.name}
            </Link>
          </Box>
        </Box>
        <Divider />
        <Box p={2}>
          {sections.map((section) => (
            <List
              key={section.subheader}
              subheader={
                <ListSubheader disableGutters disableSticky>
                  {section.subheader}
                </ListSubheader>
              }
            >
              {renderNavItems({
                items: section.items,
                pathname: location.pathname,
              })}
            </List>
          ))}
        </Box>
        <Divider />
      </PerfectScrollbar>
    </Box>
  )

  return (
    <>
      {/* <Hidden lgUp> */}
      <Hidden>
        <Drawer
          anchor='left'
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant='temporary'
        >
          {content}
        </Drawer>
      </Hidden>
      {/* <Hidden mdDown>
        <Drawer
          anchor='left'
          classes={{ paper: classes.desktopDrawer }}
          open
          variant='persistent'
        >
          {content}
        </Drawer>
      </Hidden> */}
    </>
  )
}

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
}

export default NavBar
